<template>
  <div>
    <v-row>
      <!-- Class section -->
      <v-col cols="12">
        <StudentClass :classData="student.classes" />
      </v-col>

      <!-- Calendar section -->
      <v-col cols="12" class="pa-3">
        <v-card outlined>
          <v-card-title class="d-flex flex-column pa-4">
            <div class="d-flex align-center mb-4">
              <div class="text-h6 font-weight-medium">Lịch học</div>
            </div>

            <v-divider class="w-100 mb-4"></v-divider>
            
            <!-- Calendar navigation -->
            <div class="w-100">
              <!-- Date range display -->
              <div class="d-flex justify-center align-center mb-4">
                <span class="text-subtitle-1">Tuần từ:</span>
                <span class="font-weight-medium mx-2">{{ startOfWeek }}</span>
                <span class="text-subtitle-1">đến</span>
                <span class="font-weight-medium ml-2">{{ endOfWeek }}</span>
              </div>

              <!-- Navigation buttons -->
              <div class="d-flex justify-space-between">
                <v-btn 
                  outlined 
                  color="primary"
                  @click="previousWeek"
                  class="navigation-btn"
                >
                  <v-icon size="20" class="mr-1">mdi-chevron-left</v-icon>
                  <span class="d-none d-sm-inline">Tuần trước</span>
                </v-btn>

                <v-btn
                  outlined
                  color="primary" 
                  @click="nextWeek"
                  class="navigation-btn"
                >
                  <span class="d-none d-sm-inline">Tuần sau</span>
                  <v-icon size="20" class="ml-1">mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-0">
            <div class="pa-4">
              <StudentCalendar :calendarLoading="calendarLoading" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Violation section -->
      <v-col cols="12" v-if="$auth.policies['view-violation-list']">
        <v-card outlined>
          <v-card-title class="d-flex flex-wrap align-center pa-4">
            <div class="d-flex align-center">
              <v-icon color="primary" size="24">mdi-star</v-icon>
              <span class="text-subtitle-1 font-weight-medium ml-2">Ghi chú cần theo dõi</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              class="text-none px-0"
              :to="`/complimented/?student=${student.id}`"
            >
              {{ $vuetify.breakpoint.smAndUp ? 'Xem chi tiết' : 'Chi tiết' }}
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-0">
            <v-row class="pa-6">
              <v-col cols="6" class="text-center">
                <div class="text-h5 success--text font-weight-medium mb-2">
                  {{ commendCount }}
                </div>
                <div class="text-subtitle-2">Về học tập</div>
              </v-col>

              <v-divider vertical></v-divider>

              <v-col cols="6" class="text-center">
                <div class="text-h5 warning--text font-weight-medium mb-2">
                  {{ violationCount }}
                </div>
                <div class="text-subtitle-2">Về nội dung khác</div>
              </v-col>
            </v-row>

            <ViolationDataTable 
              :hideFooter="true"
              :headers="violationHeader"
              ref="violationDataTable"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import AttendanceStudentDataTable from '@/views/attendance/components/AttendanceStudentDataTable'
import ViolationDataTable from '@/views/violation/components/ViolationDataTable'
// import StudentProfileMarks from './StudentProfileMarks.vue'
// import StudentExtraClass from './StudentExtraClass.vue'
// import StudentProfileNotifications from './StudentProfileNotifications.vue'
// import StudentAttendance from './StudentAttendance.vue'
// import StudentOnlineStudy from './StudentOnlineStudy.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import StudentClass from './StudentClass.vue'
import StudentCalendar from './StudentCalendar.vue'
import { Diligence } from '@/plugins/api'
import moment from 'moment'
// import StudentAdminClass from './StudentAdminClass.vue'

export default {
  data() {
    return {
      tab: null,
      commendCount: 0,
      violationCount: 0,
      totalAbsent: 0,
      invalidAbsent: 0,
      violationHeader: [
        { text: 'Ngày', value: 'date' },
        { text: 'Mục', value: 'type' },
        { text: 'Nội dung', value: 'description' },
      ],
      attendanceHeaders: [
        { text: 'Ngày', value: 'date' },
        { text: 'Giờ đến / Giờ về', value: 'time' },
        { text: 'Trạng thái', value: 'status', align: 'center' },
      ],
      isShowExtraCurriculum: false,
      calendarLoading: false,
      currentDate: null,
      startOfWeek: '',
      endOfWeek: '',
    }
  },
  components: {
    // StudentProfileMarks,
    // StudentExtraClass,
    ViolationDataTable,
    // AttendanceStudentDataTable,
    // StudentProfileNotifications,
    // StudentOnlineStudy,
    StudentClass,
    StudentCalendar,
    // StudentAttendance,
    // StudentAdminClass,
  },
  props: {
    student: Object,
  },
  computed: {
    ...mapState('violation', ['violations']),
    ...mapGetters('attendance', ['attendances']),
    ...mapState('app', ['currentSemester']),
  },
  async created() {
    if (this.student.classes.length > 1) {
      this.isShowExtraCurriculum = true
    } else {
      this.isShowExtraCurriculum = false
    }
    this.commendCount = await this.count({
      student: this.student.id,
      type: 'commendation',
    })
    this.violationCount = await this.count({
      student: this.student.id,
      type: 'violation',
    })
    this.totalAbsent = await Diligence.count({
      student: this.student.id,
    })
    this.invalidAbsent = await Diligence.count({
      student: this.student.id,
      type: 'invalid',
    })
    await this.getStudentCalendar()
  },
  mounted() {
    if (this.$refs.violationDataTable) {
      this.$refs.violationDataTable.refresh({
        student: this.student.id,
        _limit: 10,
      })
    }
  },
  methods: {
    ...mapActions('violation', ['count']),
    ...mapActions('attendance', ['fetchAttendances']),
    ...mapActions({
      findTimeTable: 'lessonAttendance/findTimeTable',
    }),
    async previousWeek() {
      if (this.currentDate === null) this.$alert.error('Đang tải dữ liệu, Vui lòng đợi')
      const newDate = moment(this.currentDate).subtract(7, 'days').toISOString()
      await this.getStudentCalendar(newDate)
    },
    async nextWeek() {
      if (this.currentDate === null) this.$alert.error('Đang tải dữ liệu, Vui lòng đợi')
      const newDate = moment(this.currentDate).add(7, 'days').toISOString()
      await this.getStudentCalendar(newDate)
    },
    async getStudentCalendar(date = null) {
      this.calendarLoading = true
      try {
        let selectedDate = null
        if (!date) selectedDate = moment().toISOString()
        else selectedDate = date
        await this.findTimeTable({ type: 'student', id: this.student.id, date: selectedDate })
        this.currentDate = selectedDate
        this.startOfWeek = moment(selectedDate).startOf('week').format('DD/MM')
        this.endOfWeek = moment(selectedDate).endOf('week').format('DD/MM')
      } catch (error) {
        this.$alert.error('Không tải được thời khoá biểu')
      } finally {
        this.calendarLoading = false
      }
    },
  },
}
</script>

<style scoped>
.w-100 {
  width: 100%;
}

.navigation-btn {
  min-width: 40px !important;
}

@media (max-width: 600px) {
  .text-h6 {
    font-size: 1.125rem !important;
  }
  
  .text-subtitle-1 {
    font-size: 0.875rem !important;
  }
  
  .text-subtitle-2 {
    font-size: 0.75rem !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
}
</style>
